import { getStatsUrl, request } from '../../utils/request.js';
import { MyTrackerStatus } from './types.js';

class MyTrackerService {
    config;
    constructor(config){
        this.config = config;
    }
    init() {
        this.getTrackerId().then((response)=>{
            if (response?.response?.active === MyTrackerStatus.ON) {
                this.includeOnPage(response.response.tracker_id);
            }
        }).catch(console.error);
    }
    getTrackerId() {
        const url = getStatsUrl('vkid_sdk_get_config', this.config);
        return request(url, {});
    }
    includeOnPage(trackerId) {
        // @ts-expect-error
        const _tmr = window._tmr || (window._tmr = []);
        _tmr.push({
            id: trackerId,
            type: 'pageView',
            start: new Date().getTime()
        });
        if (document.getElementById('tmr-code')) {
            return;
        }
        const ts = document.createElement('script');
        ts.type = 'text/javascript';
        ts.async = true;
        ts.id = 'tmr-code';
        ts.src = 'https://mytopf.com/js/code.js';
        const s = document.getElementsByTagName('script')[0];
        // @ts-expect-error
        s.parentNode.insertBefore(ts, s);
    }
}

export { MyTrackerService };
